import "./Logo.css"

function Logo(){
    return (
        <span className="Logo">Fruit shop</span>
    )
}

export default Logo